import { __decorate, __read, __spreadArray } from "tslib";
import { singleton } from 'mana-syringe';
import { GeometryAABBUpdater } from './interfaces';
import { Shape } from '../../types';

var PolylineUpdater =
/** @class */
function () {
  function PolylineUpdater() {}

  PolylineUpdater.prototype.update = function (parsedStyle) {
    var points = parsedStyle.points.points; // FIXME: account for miter lineJoin

    var minX = Math.min.apply(Math, __spreadArray([], __read(points.map(function (point) {
      return point[0];
    })), false));
    var maxX = Math.max.apply(Math, __spreadArray([], __read(points.map(function (point) {
      return point[0];
    })), false));
    var minY = Math.min.apply(Math, __spreadArray([], __read(points.map(function (point) {
      return point[1];
    })), false));
    var maxY = Math.max.apply(Math, __spreadArray([], __read(points.map(function (point) {
      return point[1];
    })), false));
    var width = maxX - minX;
    var height = maxY - minY;
    return {
      width: width,
      height: height,
      x: minX,
      y: minY
    };
  };

  PolylineUpdater = __decorate([singleton({
    token: [{
      token: GeometryAABBUpdater,
      named: Shape.POLYLINE
    }, {
      token: GeometryAABBUpdater,
      named: Shape.POLYGON
    }]
  })], PolylineUpdater);
  return PolylineUpdater;
}();

export { PolylineUpdater };